export default __webpack_public_path__ + "2ce4d82354fdf1be1788c526d94eefc1.woff";